import { useLocalStorage } from '@tcs/common/hooks/useLocalStorage';
import { RecentItemType } from '@tcs/client-portal-common/components/molecules/Search/types';
import { Account } from '@tcs/client-portal-api/types/Account';
import { Representative } from '@tcs/client-portal-api/types/Representative';

type RecentItemsType = { [k: string]: RecentItemType[] };

type Props = {
  recentItems: RecentItemsType;
  addRecentItem: (account: RecentItemType, persona: string) => void;
};

const MAX_LENGTH = 10;

export const useRecentlyViewedAccounts = (accountId: string): Props => {
  const [recentItems, setItem] = useLocalStorage<RecentItemsType>(
    `${accountId}_recentlyViewed`,
    {}
  );

  const addRecentItem = (account: RecentItemType, persona: string) => {
    const typeList =
      recentItems[persona]
        ?.filter((item) => account.id !== item.id)
        .slice(0, MAX_LENGTH - 1) || [];
    typeList.unshift(account);
    setItem({ ...recentItems, ...{ [persona]: typeList } });
  };

  return {
    recentItems,
    addRecentItem,
  };
};

export const recentItemFromAccount = (account: Account): RecentItemType => {
  return {
    id: account?.accountNumber,
    type: account?.displayAccountType,
    name: `${account?.firstName} ${account?.lastName}`,
  };
};

export const recentItemFromRepresentative = (
  representative: Representative
): RecentItemType => {
  return {
    id: representative?.representativeCode,
    type: null,
    name: representative?.name,
  };
};

export default useRecentlyViewedAccounts;
